import React, { forwardRef } from 'react';
import { useTheme } from '@mui/material/styles';
import MDTypographyRoot from './MDTypographyRoot';
import { FFTheme } from '../../assets/theme';
import { TypographyProps } from '@mui/material/Typography';

export type MDTypographyProps = Omit<TypographyProps, 'color'> & {
  fontWeight?: 'light' | 'regular' | 'medium' | 'bold';
  color?:
    | 'inherit'
    | 'primary'
    | 'secondary'
    | 'info'
    | 'success'
    | 'warning'
    | 'error'
    | 'light'
    | 'dark'
    | 'text'
    | 'white';
  textTransform?: 'none' | 'capitalize' | 'uppercase' | 'lowercase';
  verticalAlign?:
    | 'unset'
    | 'baseline'
    | 'sub'
    | 'super'
    | 'text-top'
    | 'text-bottom'
    | 'middle'
    | 'top'
    | 'bottom';
  textGradient?: boolean;
  opacity?: number;
  children: React.ReactNode;
  component?: React.ElementType<any>;
  to?: string;
  href?: string;
};

const MDTypography = forwardRef<HTMLSpanElement, MDTypographyProps>(
  (
    {
      color = 'dark',
      fontWeight = 'regular',
      textTransform = 'none',
      verticalAlign = 'unset',
      textGradient = false,
      opacity = 1,
      children,
      ...rest
    },
    ref
  ) => {
    const theme = useTheme<FFTheme>();
    // const [controller] = useMaterialUIController();
    // const { darkMode } = controller;

    return (
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-ignore
      <MDTypographyRoot
        {...rest}
        ref={ref}
        theme={theme}
        ownerState={{
          color,
          textTransform,
          verticalAlign,
          fontWeight,
          opacity,
          textGradient,
          //   darkMode,
        }}
      >
        {children}
      </MDTypographyRoot>
    );
  }
);

MDTypography.displayName = 'MDTypography';

export { MDTypography };
